import React, {memo} from 'react';
import {Box, Fade} from "@mui/material";
import {COMPANY_NAME} from "../config/constants";

const Spinner = () => {
    return (
            <main
                style={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >

                <Fade in={true} timeout={1000}>
                    <Box
                        component='img'
                        alt={COMPANY_NAME}
                        sx={{
                            width: {xs: '20%'},
                        }}
                        src={'/assets/pngs/origin-original-logo.png'}
                    />
                </Fade>
            </main>
    );
}

export default memo(Spinner);